export const getCategoryLink = (productCategory: string | undefined) => {
  if (
    productCategory === 'basin-mixers' ||
    productCategory === 'kitchen-tapware' ||
    productCategory === 'laundry-tapware' ||
    productCategory === 'care-tapware' ||
    productCategory === 'bath-shower-mixers' ||
    productCategory === 'care-accessories' ||
    productCategory === 'bathroom-holders' ||
    productCategory === 'shelves-cabinets' ||
    productCategory === 'soap-accessories' ||
    productCategory === 'toilet-roll-accessories' ||
    productCategory === 'towel-accessories' ||
    productCategory === 'tapware-spare-parts' ||
    productCategory === 'outlets-spouts' ||
    productCategory === 'three-piece-tapware' ||
    productCategory === 'tapware-assemblies' ||
    productCategory === 'tapware'
  )
  return '/tapware-and-accessories/';

  if (
    productCategory === 'shower-systems' ||
    productCategory === 'shower-heads-outlets' ||
    productCategory === 'shower-spare-parts' ||
    productCategory === 'showers' 
  )
  return '/showers/';

  return '/';
};
